//To do : Add real time to the data using Date() function
// adding also search by keywords , filter out by keywords

import { Fragment, useEffect, useRef, useState } from 'react'
import { Dialog, Disclosure, Menu, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon, FunnelIcon, MinusIcon, PlusIcon, Squares2X2Icon } from '@heroicons/react/20/solid'
import DataGrid from './videoGrid'
import fetchApi from './Api'
import CategoryButtons from './sub-components/CategoryButtons'
import Sidebar from './sub-components/Sidebar'
import { Link, useNavigate } from 'react-router-dom'
import CardLoadingSkeletion from './sub-components/CardLoadingSkeleton'

import InfiniteScroll from 'react-infinite-scroll-component';
import ReactLoading from "react-loading";
import fetchApi2 from './FetchData'
import { queryByTestId } from '@testing-library/react'


export default function MainGrid({ ...props}) {

  const sortOptions = [
    { name: '1 Hour', func: (value) => { setFilterQueries({ "url": "&order_by=last_hour", "idx": 1 }); filterQueriesChanged('&order_by=last_hour') }, current: false },
    { name: 'Today', func: (value) => { setFilterQueries({ "url": "&order_by=today", "idx": 2 }); filterQueriesChanged('&order_by=today') }, current: false },
    { name: '1 Week', func: (value) => { setFilterQueries({ "url": "&order_by=this_week", "idx": 3 }); filterQueriesChanged('&order_by=this_week') }, current: false },
    { name: '1 Month', func: (value) => { setFilterQueries({ "url": "&order_by=this_month", "idx": 4 }); filterQueriesChanged('&order_by=this_month') }, current: false },
    { name: '1 year', func: (value) => { setFilterQueries({ "url": "&order_by=this_year", "idx": 5 }) ; filterQueriesChanged('&order_by=this_year')}, current: false },
  ];



  const SidebarOptions = [
    { name: 'Most Popular', func: (value) => setselectedCategory(value), current: true },
    { name: 'Best Rating', func: (value) => setselectedCategory(value), current: false },
    { name: 'Newest', func: (value) => setselectedCategory(value), current: false },
    { name: 'Price: Low to High', func: (value) => setselectedCategory(value), current: false },
    { name: 'Price: High to Low', func: (value) => setselectedCategory(value), current: false },
  ]

  const subCategories = [
    { name: 'All', func: (value) => submitInput(value) },
    { name: 'Food', func: (value) => submitInput(value) },
    { name: 'CodeWithHarry', func: (value) => submitInput(value) },
    { name: 'Politics', func: (value) => submitInput(value) },
    { name: 'ReactJs', func: (value) => submitInput(value) },
    { name: 'Windows', func: (value) => submitInput(value) },
    { name: 'News', func: (value) => submitInput(value) },
    { name: 'Entertainment', func: (value) => submitInput(value) },
  ]

  const filters = [
    {
      id: 'category',
      name: 'Category',
      options: [
        { value: 'new-arrivals', label: 'New Arrivals', checked: false },
        { value: 'sale', label: 'Sale', checked: false },
        { value: 'travel', label: 'Travel', checked: true },
        { value: 'organization', label: 'Organization', checked: false },
        { value: 'accessories', label: 'Accessories', checked: false },
      ],
    },

  ]

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  let layout = ['grid-cols-3', 'grid-cols-4', 'grid-cols-2']
  let theme = 'light';
  let {selectedCategory,databaseDataLength,setDatabaseDataLength, setselectedCategory, blur, setIsDrawerVisible,isDrawerVisible ,userDetails, setUserDetails, VedioArr, AllFetchedData, setVedioArr,setAllFetchedData ,setPage,setLoading, page, Loading, displayName, setDisplayName} = props;

  

  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)
  const [filterQueries, setFilterQueries] = useState(null)
  const [gridLayout, setGridLayout] = useState("grid-cols-3");
  const prevRef = useRef();
  const navigate = useNavigate();
  // const [Loading, setLoading] = useState(true)
  // const [page, setPage] = useState(1);
  // const [databaseDataLength, setDatabaseDataLength] = useState(0);
  // const [VedioArr, setVedioArr] = useState([])
  // const [AllFetchedData, setAllFetchedData] = useState([]);

  const changeLayout = () => {
    let idx = layout.findIndex((value) => value === gridLayout);
    
    
    if (idx === 2)
      idx = 0;
    else
      idx++;

    setGridLayout(layout[idx]);

  }



  const addToDatabase = async (vidData) => {


    
    
    try {

      let uri = process.env.REACT_APP_Realtime_Firebase;
      let response = await fetch(uri + 'MyData.json', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
  
        body: JSON.stringify(vidData)
      })
      
      
    }
    catch(e){
      
    }

    // if (response) {
    
    // }
    // else {
    
    // }


  }


  const GetFirebaseData = async (category) => {

    
    let uri = process.env.REACT_APP_Realtime_Firebase;
    

          try{
          
          let response = await fetch(uri + 'MyData.json')
          response = await response.json();


          let newArray = [];

          
          

          for (let key in response) {

            // Check the condition for each value
            if (response[key]?.keywords?.includes(category)) {
              // Add the value to the new array if it matches the condition
              newArray.push(response[key]);
            }



          }

          
          
          

          return newArray.length === 0 ? null : newArray;
        }
        catch(e)
        {
          alert("Something went wrong. Please try again.")
        }
  }

  const filterCatgegoryOut = async (category) => {
    return await GetFirebaseData(category ?? selectedCategory);
  }


const changeQueryToOrignalForm = (category)=>
{
  
  let query = category;
  let modifiedQuery = '';

      
  for(let i = 0; i < query.length; i++) {
    if(query[i] == '+') {
      modifiedQuery += ' ';
    } else {
      modifiedQuery += query[i];
    }
  }

  return modifiedQuery;

}


const submitInput = (input) => {
   
    

  // allowMobileSearch(false);

  
  setMobileFiltersOpen(false)
  setselectedCategory(input);
  // setsearchValue("")
  setLoading(true)
  setPage(0);
  setDatabaseDataLength(0);
  setAllFetchedData([]);
  
  let query = input;
  let modifiedQuery = '';

    
for(let i = 0; i < query.length; i++) {
  if(query[i] == ' ') {
    modifiedQuery += '+';
  } else {
    modifiedQuery += query[i];
  }
}

setselectedCategory(modifiedQuery);


if(window.location.pathname === '/')
{
filterCatgegoryOut(input).then((data) => {

  if (data === null ) {

    try {

      // fetching data from V2

      fetchApi('search/?part=snippet', '&country=in&query=' + modifiedQuery + `&page=${page}${filterQueries ? filterQueries.url : ''}`)
        .then((videos) => {

          
          setFilterQueries({})

         
          let vidData = videos?.data?.videos;
          
          
          setVedioArr(vidData);

          setAllFetchedData(vidData);
          setDatabaseDataLength(vidData?.length);

          



          // adding data into database
          vidData?.forEach(ele => {
            // adding category
            ele.keywords.push(input)

            


            addToDatabase(ele)
          });
          
          setLoading(false)
        })
    }
    catch (e) {
      
    }
  }
  else  {

    // AllFetchedData = data;

    //data found

    
    setAllFetchedData(data);
    

    setTimeout(() => {
      setLoading(false)
    }, Math.floor(Math.random() * 4))


    // setVedioArr(data.slice(databaseDataLength, databaseDataLength + 30));
    setVedioArr(data.slice(0, 30));
    // databaseDataLength += 30;
    // setDatabaseDataLength(databaseDataLength+30)
    setDatabaseDataLength(30)
  }
})
  .catch()
{
  
}
}
else{
navigate('/')
}
  
}

  useEffect(() => {

    let data = JSON.parse(localStorage.getItem("userDetails"))
    if(data && data.name)
      {
        
        setDisplayName(data?.name[0]?.toUpperCase())
      }
   
    if(prevRef.current == undefined)
    {
        setLoading(true)
        setPage(0);
        setDatabaseDataLength(0);
        
        let query = selectedCategory;
        let modifiedQuery = '';

            
        for(let i = 0; i < query.length; i++) {
          if(query[i] == ' ') {
            modifiedQuery += '+';
          } else {
            modifiedQuery += query[i];
          }
        }

        setselectedCategory(modifiedQuery);
        
        filterCatgegoryOut().then((data) => {

          if (data === null ) {


        


            try {

              // fetching data from V2

              fetchApi('search/?part=snippet', '&country=in&query=' + modifiedQuery + `&page=${page}${filterQueries ? filterQueries.url : ''}`)
                .then((videos) => {

                  
                  setFilterQueries({})

                  let vidData = videos?.data?.videos;
                  
                  
                  setVedioArr(vidData);


                  // adding data into database
                  vidData?.forEach(ele => {
                    // adding category
                    ele.keywords.push(selectedCategory)

                    


                    addToDatabase(ele)
                  });

                  setLoading(false)
                  prevRef.current = true;
                })
            }
            catch (e) {
              
            }
          }
          else {

            // AllFetchedData = data;
            
            setAllFetchedData(data);

            setTimeout(() => {
              setLoading(false)
            }, Math.floor(Math.random() * 4))


            // setVedioArr(data.slice(databaseDataLength, databaseDataLength + 30));
            setVedioArr(data?.slice(0, 30));
            // databaseDataLength += 30;
            // setDatabaseDataLength(databaseDataLength+30)
            setDatabaseDataLength(30)
            prevRef.current = true;

          }
        })
          .catch()
        {
          
        }
  }

  }, [])


  

  const filterQueriesChanged = (filterQuery)=>{
 
    if(filterQueries)
      {
            // setLoading(true)
      setDatabaseDataLength(0);
      
      
      
  
        // if (data === null  || filterQueries.url) {
  
  
      
    
  
          try {
  
            // fetching data from V2
  
            fetchApi('search/?part=snippet', '&country=in&query=' + selectedCategory + filterQuery + `&page=${0}`)
              .then((videos) => {
  
  
                setFilterQueries({})
  
                let vidData = videos?.data?.videos;
                
                
                setVedioArr(vidData);
  
                // adding data into database
                // vidData.forEach(ele => {
                //   // adding category
                //   ele.keywords.push(selectedCategory)
  
                  
  
  
                //   addToDatabase(ele)
                // });
  
                setLoading(false)
              })
          }
          catch (e) {
            
          }
          finally{
            setFilterQueries(null);
          }
        }
  }




  

  const [hasMore, setHasMore] = useState(true);

  const cheakForRequests = async(data)=>{

    if(data['totalRequest'] >= 35)
    {
      setInterval(() => {
        alert("Please come back tommorrow!!!")
      }, 4000);

      return ;
    }

      if(data['totalRequest'] == 15 || data['totalRequest'] == 30 )
      { 
        try {

          let response = await fetch('https://play-tube-418206-default-rtdb.firebaseio.com/limitCross.json', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json"
            },
      
            body: JSON.stringify(data)
          })
          
          alert('You have crossed limit...')
        
        }
        catch(e){
            
        }
    
      }
    
  }


  const loadMoreItems = pageSQ => {
    let data = JSON.parse(localStorage.getItem("userDetails"))
    cheakForRequests(data);
    
    // setHasMore(false)


    
    // fetchApi('search/?part=snippet&country=in&query=' + selectedCategory + (filterQueries.url ?? "") + `&page=${4}&`)
    // .then((videos) => {

    //   setVedioArr(prev => [...prev, ...videos.data.videos]);
    

    //   // setTimeout(() => {
    //   //   setHasMore(true)


    //   // }, 5000)
    
    //   return true
    // })

   
      

      
      let tempPage = page + 1;
      setPage(page + 1);

      
    if (AllFetchedData.length > databaseDataLength) {

      
      

      let tempData = AllFetchedData.slice(databaseDataLength, databaseDataLength + 30)
      // databaseDataLength += 30;
      setDatabaseDataLength(databaseDataLength+30);


      

      setVedioArr(prev => [...prev, ...tempData]);

      setTimeout(() => {
        setHasMore(true)


      }, 5000)
    }
    else {



      
      fetchApi('search/?part=snippet&country=in&query=' + selectedCategory + `&page=${tempPage}&`)
        .then((videos) => {

          


          // adding data into database
          let cate = changeQueryToOrignalForm(selectedCategory);
          videos.data.videos.forEach(ele => {
            // adding category
            ele.keywords.push(cate)

            
            
            
            addToDatabase(ele)
          });
          
          

          setVedioArr(prev => [...prev, ...videos.data.videos]);
          
          setTimeout(() => {
            setHasMore(true)


          }, 5000)

          data['totalRequest']++;
          localStorage.setItem("userDetails", JSON.stringify(data) )  ;
      
          
          return true
        })
      setHasMore(true)
      
    }

    return true;
  };

  return (
    <div className="bg-red-500 ">
      <div>
        {/* Mobile filter dialog */}
        <Transition.Root show={mobileFiltersOpen} as={Fragment}>
          <Dialog as="div" className="relative z-40 lg:hidden" onClose={setMobileFiltersOpen}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-black text-white py-4 pb-12 shadow-xl">
                  <div className="flex items-center justify-between px-4">
                    <h2 className="text-lg font-medium text-gray-300">Filters</h2>
                    <button
                      type="button"
                      className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-black p-2 text-gray-400"
                      onClick={() => setMobileFiltersOpen(false)}
                    >
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>

                  {/* Filters */}
                  <form onSubmit={(e) => e.preventDefault()} className="mt-4 border-t bg-black border-gray-200">
                    <h3 className="sr-only">Categories</h3>
                    <ul role="list" className="px-2 py-3 font-medium text-gray-300">
                      {subCategories.map((category) => (
                        <li className="hover:bg-red-700 w-full text-start focus:bg-red-700 focus:text-white" key={category.name}>
                          <button onClick={() => category.func(category.name)} className="block px-2 py-3 hover:bg-red-700 focus:bg-red-700 ">
                            {category.name}
                          </button>
                        </li>
                      ))}
                    </ul>

                   
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>



        <CategoryButtons submitInput={submitInput} setIsDrawerVisible={setIsDrawerVisible} isDrawerVisible={isDrawerVisible} category={selectedCategory} setCategory={setselectedCategory} />


        <main className="px-1  sm:px-6 lg:px-8 bg-black">
          <div className="flex items-baseline justify-between border-b border-gray-200 pb-6 ">
            <div onClick={()=>setIsDrawerVisible(!isDrawerVisible)} className="text-xl font-semibold tracking-tight text-white flex w-fit">Results for : <p className='text-red-500 ml-2 '>{`${changeQueryToOrignalForm(selectedCategory)}`}</p></div>

            <div className="flex items-center">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button className={`group inline-flex justify-center text-sm font-medium ${theme==='light' ? 'text-gray-400 hover:text-gray-200': 'text-gray-700 hover:text-gray-900'} `}>
                    Sort
                    
                    <ChevronDownIcon
                      className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute cursor-pointer bg-white right-0 z-10 mt-2 w-40 origin-top-right rounded-md  shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className=" w-full">
                      {sortOptions.map((option) => (
                        <Menu.Item key={option.name}>
                          {({ active }) => (
                            <button
                              onClick={() => {
                                option.func();
                                option.current = true;
                                // submitInput(selectedCategory);
                              }}
                              className={classNames(
                                option.current ? 'w-[100%] text-start font-medium text-gray-900' : 'w-[100%] text-start font-medium text-gray-900',
                                active ? 'bg-gray-100' : '',
                                'block px-4 py-2 text-sm'
                              )}
                            >
                              {option.name}
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>

              <button type="button" onClick={() => changeLayout()} className="-m-2 ml-5 p-2 hidden sm:block text-gray-400 hover:text-gray-500 sm:ml-7">
                <span className="sr-only">View grid</span>
                <Squares2X2Icon className="h-5 w-5" aria-hidden="true" />
              </button>
              <button
                type="button"
                className="-m-2 ml-4 p-2  text-red-400 hover:text-gray-500 sm:ml-6 lg:hidden"
                onClick={() => setMobileFiltersOpen(true)}
              >
                <span className="sr-only">Filters</span>
                <FunnelIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>

          <section aria-labelledby="products-heading" className="pb-24 pt-6">
            <h2 id="products-heading" className="sr-only">
              Products
            </h2>

            {/* <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-5"> */}
            <div className=" sm:gap-x-8 gap-y-10 flex justify-between ">
              {/* Filters */}
              {/* <form className="hidden lg:block">
                <h3 className="sr-only">Categories</h3>
                <ul role="list" className="space-y-4 border-b border-gray-200 pb-6 text-sm font-medium text-gray-900">
                  {subCategories.map((category) => (
                    <li  className="hover:bg-red-300 focus:bg-red-500 focus:text-white" key={category.name}>
                      <a href={category.href}>{"hello"}</a>
                    </li>
                  ))}
                </ul>

                {filters.map((section) => (
                  <Disclosure as="div" key={section.id} className="border-b border-gray-200 py-6">
                    {({ open }) => (
                      <>
                        <h3 className="-my-3 flow-root">
                          <Disclosure.Button className="flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500">
                            <span className="font-medium text-gray-900">{section.name}</span>
                            <span className="ml-6 flex items-center">
                              {open ? (
                                <MinusIcon className="h-5 w-5" aria-hidden="true" />
                              ) : (
                                <PlusIcon className="h-5 w-5" aria-hidden="true" />
                              )}
                            </span>
                          </Disclosure.Button>
                        </h3>
                        <Disclosure.Panel className="pt-6">
                          <div className="space-y-4">
                            {section.options.map((option, optionIdx) => (
                              <div key={option.value} className="flex items-center">
                                <input
                                  id={`filter-${section.id}-${optionIdx}`}
                                  name={`${section.id}[]`}
                                  defaultValue={option.value}
                                  type="checkbox"
                                  defaultChecked={option.checked}
                                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                />
                                <label
                                  htmlFor={`filter-${section.id}-${optionIdx}`}
                                  className="ml-3 text-sm text-gray-600"
                                >
                                  {option.label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                ))} 
              </form> */}


              {/* // side bar  */}

             

                <Sidebar setIsDrawerVisible={setIsDrawerVisible} isDrawerVisible={isDrawerVisible}/>
              



              {/* Product grid */}
              <div className=" w-full sm:ml-6 bg-black">
                {Loading ? <div className={` w-full sm:w-[83vw] grid grid-cols-1 sm:gap-x-2 gap-y-8  lg:${gridLayout} text-white`}>
                  <CardLoadingSkeletion></CardLoadingSkeletion>
                  <CardLoadingSkeletion></CardLoadingSkeletion>
                  <CardLoadingSkeletion></CardLoadingSkeletion>
                  <CardLoadingSkeletion></CardLoadingSkeletion>
                  <CardLoadingSkeletion></CardLoadingSkeletion>
                  <CardLoadingSkeletion></CardLoadingSkeletion>

                  <CardLoadingSkeletion></CardLoadingSkeletion>
                  <CardLoadingSkeletion></CardLoadingSkeletion>


                </div>
                  :

                  <div className=' bg-black'>
                    <InfiniteScroll
                      className={'bg-black'}
                       dataLength={VedioArr?.length}
                       next={VedioArr?.length > 0 && loadMoreItems} // Function to call when scrolling to the bottom
                       hasMore={hasMore} // Indicates whether more items can be loaded
                       loader={<div className=' bg-black'>
                       <ReactLoading className="mx-auto" type={'balls'} color={'white'} height={'5%'} width={'5%'} />
                     </div>} // Loader component to display while loading
                       endMessage={<p>No more items to be loaded</p>} // Message displayed when all items are loaded

                      
                    >
                      
                
                      <DataGrid gridLayout={gridLayout} vedios={VedioArr} blur={blur} />
                      
                    </InfiniteScroll>

                  </div>
                }
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  )
}